import React from 'react';
import Anchor from '@/components/ui/Anchor';
import { cleanUpDeleteButton } from '@/components/shared/Froala/plugins/VocabBox/vocabBoxUtils';

interface DeleteVocabDisplayProps {
  containerId: string;
  editor: any;
  vocabElement: HTMLElement;
}

const DeleteVocabDisplay = ({ containerId, editor, vocabElement } : DeleteVocabDisplayProps) => {
  if (!vocabElement) return null;

  const deleteNode = () => {
    vocabElement.remove();

    editor.html.set(editor.html.get());
    editor.undo.saveStep();
    editor.events.trigger('contentChanged');

    setTimeout(() => cleanUpDeleteButton(containerId), 100);
  };

  return (
    <Anchor
      offset={{ top: 55 }}
      to={vocabElement}
    >
      <button
        className="tw-h-12 tw-w-24 tw-bg-white tw-outline-none tw-rounded-lg tw-shadow-xl tw-border-none"
        id="vocabDeleteButton"
        type="button"
        onClick={deleteNode}
      >
        <span className="tw-text-red">
          <i className="fa fa-trash-o fa-2x" />
        </span>
      </button>
    </Anchor>
  );
};

export default DeleteVocabDisplay;
